import { createSlice } from "@reduxjs/toolkit"

export const sessionSlice = createSlice({
  name: "auth/session",
  initialState: {
    token: "",
    signedIn: false,
  },
  reducers: {
    onSignInSuccess: (state, action) => {
      console.log(action)
      state.signedIn = true
      state.token = action.payload.token
      state.refreshToken = action.payload.refreshToken
    },
    onSignOutSuccess: (state) => {
      state.signedIn = false
      state.token = ""
      state.refreshToken = ""
    },
    setToken: (state, action) => {
      state.token = action.payload.token
      state.refreshToken = action.payload.refreshToken
    },
  },
})

export const { onSignInSuccess, onSignOutSuccess, setToken } = sessionSlice.actions

export default sessionSlice.reducer
